import { userConstant } from '../constants';

let loggedInUser = JSON.parse(localStorage.getItem('user'));
const initialState = loggedInUser ? { loggedIn: true, loggedInUser } : {};

export function userAuth(state = initialState, action) {
    switch (action.type) {
        case userConstant.LOGIN_REQUEST:
            return {
                loggingIn: true,
                user: action.user,
            };
        case userConstant.LOGIN_SUCCESS:
            return {
                loggedIn: true,
                loggedInUser: JSON.parse(localStorage.getItem('user'))
            };
        case userConstant.LOGIN_FAILURE:
            //Check if any error message is coming from API otherwise display network API error
            let errorMessage = "Network API Error! Please check with the admininstrator";
            if (action?.error?.response?.data?.data?.response?.message) {
                errorMessage = action?.error?.response?.data.data?.response?.message;

            }
            return {
                error: errorMessage
            };
        case userConstant.LOGOUT:
            return {};
        case userConstant.RESET_USER_STATUS:
            return {
                loggingIn: undefined,
                user: undefined,
            };
        default:
            return state;
    }
}